import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { useTranslation } from 'react-i18next';
import { FiEdit, FiTrash2, FiRefreshCcw, FiMail } from "react-icons/fi";
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';
import {
  Box,
  IconButton
} from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';
import moment from 'moment';
import { eventDateFormate } from '../../../Utils/constants';
import { getEventRegisterList, sendDynamicMail } from "../../../Utils/apiServices";
import KenSnackbar from '../../../Components/KenSnackbar/index';

import ParticipantModal from "./ParticipantModal";
import KenLoader from '../../../Components/KenLoader/index';
import FeedbackModal from './FeedbackModal';


const KenTabPanel = (props) => {
  const { t } = useTranslation();

  const { children, value, index, events, type, initialPage, ...other } = props;
  console.log("rowsPerPage :::: ", props);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openParticipantModal, setOpenParticipantModal] = React.useState(false);
  const [eventId, setEventId] = React.useState();
  const [subList, setSubList] = React.useState([]);
  const [eventDetails, setEventDetails] = React.useState(null);


  const [feedbackModalOpen, setFeedbackModalOpen] = React.useState(false);


  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [emailList, setEmailList] = React.useState([]);



  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleDynamicMail = async (payload) => {
    setLoading(true)
    if (payload.emailMessage.subject != '' && payload.emailMessage.emailBody != undefined) {
      try {
        const sendMailDetail = await sendDynamicMail(payload);
        if (Number(sendMailDetail.responseCode) === 200) {
          setFeedbackModalOpen(false);
          setSnackbarMessage(t("messages:Mail_Notification_Success"));
          setSnackbarSeverity("success")
          setOpenSnackbar(true);
          setLoading(false);
        } else {
          setSnackbarMessage(t("messages:file_upload_fail"));
          setSnackbarSeverity("error")
          setOpenSnackbar(true);
          setLoading(false);
        }

      } catch (error) {
        setLoading(false);
        setSnackbarMessage(t("messages:file_upload_fail"));
        setSnackbarSeverity("error")
        setOpenSnackbar(true);
      }
    } else {
      setLoading(false);
      setSnackbarMessage(t("messages:error_message_for_sms"));
      setSnackbarSeverity("error")
      setOpenSnackbar(true);
    }


  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const updatePageInitialValue = () => {
    setPage(initialPage)
    setRowsPerPage(10)
    console.log("rowsPerPage :::: ", page, rowsPerPage);

  }
  const getParticipantList = async (eventId) => {

    try {
      setLoading(true);
      const eventList = await getEventRegisterList(eventId);
      const Subscriber = eventList.Subscriber;
      if (Subscriber.length > 0) {
        await setSubList(Subscriber);
        await setEventDetails(eventList);
        setOpenParticipantModal(true);
      } else {
        snackbarMessage(t("messages:no_data_found"));
        setSnackbarSeverity("Error")
        setOpenSnackbar(true);
      }
      setLoading(false);

    } catch (error) {
      setLoading(false);
      setSnackbarMessage(t("messages:file_upload_fail"));
      setSnackbarSeverity("Error")
      setOpenSnackbar(true);

    }

  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const showFeedbackModal = async (row) => {
    if (row.Count === 0) {
      setSnackbarMessage(t("messages:No_One_Registered"));
      setSnackbarSeverity("Error")
      setOpenSnackbar(true);
      return;
    }
    try {
      setLoading(true);
      const eventId = row.Id;
      const eventList = await getEventRegisterList(eventId);
      const Subscriber = eventList.Subscriber;
      if (Subscriber.length > 0) {
        const emailAry = [];
        Subscriber.forEach(element => {
          const contactId = (element.ContactId != {}) ? element.ContactId : null;
          if (contactId != null) {
            emailAry.push(contactId);
          }
        });
        setEventDetails(row);
        setEmailList(emailAry);
        setFeedbackModalOpen(true);
      } else {
        setSnackbarMessage(t("messages:no_data_found"));
        setSnackbarSeverity("Error")
        setOpenSnackbar(true);
      }
      setLoading(false);

    } catch (error) {
      setLoading(false);
      setSnackbarMessage(t("messages:file_upload_fail"));
      setSnackbarSeverity("Error")
      setOpenSnackbar(true);

    }
  }

  React.useEffect(() => {
    // updatePageInitialValue()

  }, []);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Table className="table" aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell >{t('labels:Event_Details')}</TableCell>
                <TableCell >{t('labels:Status')}</TableCell>
                <TableCell >{t('labels:Actions')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

              {events
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell>
                        <div className="avtart-img">
                          { (row.Image.length > 0) ? <img
                            src={`data:image/png;base64, ${row.Image[row.Image.length - 1].Body}`}
                            alt={row.Subject}
                          /> :
                          <img src="https://images.unsplash.com/photo-1588072432836-e10032774350?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2252&q=80" />
                        }
                        </div>
                      </TableCell>
                      <TableCell >
                        <Typography variant="h6">
                          {row.Subject}
                        </Typography>
                        <p>{row.Description}</p>
                        <div className="datebox">

                          {row.Location != "null" && row.Location != null && <Chip className="chipClass" label={t("labels:Location") + ': ' + row.Location} />}

                          <Chip  className="chipClass" label={t("labels:Start") + ': ' + moment(row.StartDateTime).format(eventDateFormate)} />
                          <Chip className="chipClass" label={t("labels:End") + ': ' + moment(row.EndDateTime).format(eventDateFormate)} />
                        </div>
                        <div className="avtarbox" onClick={() => {
                          getParticipantList(row.Id)

                        }}>
                          {row.Count != 0 && <Chip className="userList" label={row.Count + " " + t("messages:registrar_user_list")} />}
                        </div>
                      </TableCell>
                      <TableCell >
                        {row.upcoming && <div className="upcomming-badge">{t('labels:Upcoming')}</div>}
                        {row.inprogress && <div className="inprogress-badge">{t('labels:In_Progress')}</div>}
                        {row.completed && <div className="completed-badge">{t('labels:Completed')}</div>}

                      </TableCell>
                      <TableCell >
                        {row.upcoming && < IconButton onClick={() => props.openEditModal(row)} aria-label="Edit">
                          <FiEdit />
                        </IconButton>}
                        {row.upcoming && <IconButton onClick={() => props.deleteEventConfirm(row)} aria-label="delete">
                          <FiTrash2 />
                        </IconButton>}


                        {row.inprogress && <IconButton aria-label="delete">
                          <FiRefreshCcw />
                        </IconButton>}

                        {row.completed && <IconButton aria-label="delete" onClick={() => showFeedbackModal(row)}>
                          <FiMail />
                        </IconButton>}

                      </TableCell>
                    </TableRow>
                  )
                })}
            </TableBody>
          </Table>


        
        </Box>
      )}

{events != null && (
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={events.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}

{loading && <KenLoader />}


      { openParticipantModal && <ParticipantModal openParticipantModal={openParticipantModal}
        setOpenParticipantModal={setOpenParticipantModal} subList={subList} eventDetails={eventDetails} />}


      {
        feedbackModalOpen && <FeedbackModal
          feedbackModalOpen={feedbackModalOpen}
          setFeedbackModalOpen={setFeedbackModalOpen} emailList={emailList} eventDetails={eventDetails} handleDynamicMail={handleDynamicMail}></FeedbackModal>
      }

      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />

    </div>
  );
}

export default KenTabPanel;
